import moment from "moment";
const CryptoJS = require("crypto-js");

export function getUrl(opciones_servicio, formResponses) {
  if (opciones_servicio) {
    const opcionesServicio = JSON.parse(opciones_servicio);
    if (!opcionesServicio.url.toLowerCase().includes("http")) {
      opcionesServicio.url = `${process.env.REACT_APP_BACKEND}${opcionesServicio.url}`;
    }
    const url = new URL(opcionesServicio.url);
    const params = new URLSearchParams(url.search.slice(1));
    let urlBase = new URL(url.origin + url.pathname);
    for (let p of params) {
      //const field = formResponses.find(item => item.key === p[0]);
      if (opcionesServicio.body.dependency && keysUrls[p[0]]) {
        p[0] = opcionesServicio.body.dependency;
      }
      let field = formResponses.find(
        (item) => item.key === (MapKeysUrl[p[0]] ? MapKeysUrl[p[0]] : p[0])
      );
      let idTipoPersona = "";
      if (!field) {
        field = formResponses.find((item) => item.key === p[0]);
        if (!field && p[0] === "tipoIdentificadorPersona") {
          const tipoDePersona = formResponses.find(
            (item) => item.key === "tipoDePersonaAsegurado"
          )?.value;
          idTipoPersona = tipoDePersona
            ? tipoDePersona === "personaFisica"
              ? 1
              : 2
            : idTipoPersona;
        }
      }
      let value =
        p[1] && p[1] !== "value"
          ? idTipoPersona
            ? idTipoPersona
            : p[1]
          : field && field.value
          ? field.value
          : null;
      const newParam = NewKeysUrl[p[0]] || p[0];

      if (urlBase.searchParams.get(newParam)) {
        value && urlBase.searchParams.set(newParam, value);
      } else {
        value && urlBase.searchParams.append(newParam, value);
      }
    }

    const newUrl = opcionesServicio.key
      ? urlBase.href.replace(opcionesServicio.key, "")
      : urlBase.href;
    opcionesServicio.url = newUrl;
    return opcionesServicio;
  }
}

const getSituations = (sJsonIssue, sPolicy) => {
  let newJsonIssue = [];
  sJsonIssue &&
    sJsonIssue.forEach((item) => {
      const situation =
        sPolicy && sPolicy.find((x) => x.numberSituation === item.riskNumber);
      const newCoverages =
        situation &&
        situation.coverages.map((val) => ({
          coverageId: val.coverageId,
          amountSumInsurance: val.insuredAmount,
        }));
      newJsonIssue = [...newJsonIssue, { ...item, coverages: newCoverages }];
    });
  return newJsonIssue;
};

export function getBodyRedirect(jsonIssue, policy) {
  const newSituations = {
    ...jsonIssue,
    situations: getSituations(jsonIssue.situations, policy.situations),
  };
  const userInfo = jsonIssue && jsonIssue.policy;
  const configuration = {
    ...jsonIssue.configuration,
    channel: userInfo.userId ? "agente" : "directo",
    product: process.env.REACT_APP_PRODUCT_NAME,
    folioFromPartner: jsonIssue.configuration.folioFromPartner,
  };
  const personalData =
    jsonIssue && jsonIssue.client && jsonIssue.client.personalData;
  const user = userInfo &&
    personalData && {
      name: userInfo.userId ? userInfo.name : "",
      email: userInfo.email ? userInfo.email : personalData.email,
      phone: userInfo.userId ? "" : personalData.phoneNumber,
    };
  const newPolicy = {
    currency: "MXN",
    formPayment: "",
    periodicity: "",
    quote: policy.policy,
    costs: policy.costs,
  };
  return { configuration, user, policy: newPolicy, jsonIssue: newSituations };
}

export function getBodyCoverage(formResponses, folio, infoUser, isSecond) {
  let coverages = [];
  const configuration = {
    partnerId: "COTIZADORES_SURA",
    product: process.env.REACT_APP_PRODUCT_NAME,
    folioFromPartner: folio,
  };
  const policy = {
    officeId: infoUser ? infoUser.oficinaId : null,
    currencyId: "MXN",
    businessDivision: null,
    atrGroupId: infoUser ? infoUser.atrGrupoId : null,
    atrSubgroupId: infoUser ? infoUser.atrSubgrupoId : null,
    atrProfileRateId: infoUser ? infoUser.atrPerfilTarifaId : null,
    atrPointSaleId: infoUser ? infoUser.atrPuntoVentaId : null,
    productId: parseInt(process.env.REACT_APP_PRODUCT_ID),
  };
  let situation = {
    modalities: isSecond ? [] : ["basica", "amplia", "movilidadTotal"],
    vehicleSerialNumber: "",
    engineNumber: "S/N",
    plateNumber: "",
    packageModalityPlan: null,
  };
  keysCoverages.forEach((k) => {
    let field = formResponses.find((item) => item.key === k.key);
    if (field) {
      switch (k.key) {
        case "versionVehiculo":
          const valuesVehicle = getValuesVehicle(
            field.value.key,
            field.valuesResponse
          );
          situation["vehicleDescAmis"] = field.value.description;
          situation[k.value] = field.value.key;
          situation = { ...situation, ...valuesVehicle };
          break;
        case "fechaNacimiento":
          const age = getDate(field.value);
          situation[k.value] = age.toString();
          break;
        case "telefono":
          situation[k.value] = infoUser ? null : field.value;
          break;
        case "email":
          situation[k.value] = infoUser ? infoUser.email : field.value;
          break;
        default:
          situation[k.value] = field.value.toString();
          break;
      }
    }
  });
  if (isSecond) {
    let field = formResponses.find((item) => item.key === "coberturas");
    situation["packageModalityPlan"] = field.modalityId;
    coverages = field.coverages.map((coverage) => {
      return {
        coverageId: coverage.coverageId,
        amountSumInsurance:
          coverage.modalities[field.modalityId].amountSumInsurance,
        atrDeducible: coverage.modalities[field.modalityId].atrDeducible,
      };
    });
  }

  return { configuration, policy, situation, coverages };
}

export function getInfoCoverages(steps) {
  if (steps && steps.length) {
    const stepCoverage = steps.find((e) => e.key_step === "step_cobertura");
    if (stepCoverage) {
      return stepCoverage.questions[0].newItems[0];
    }
  }
  return null;
}

export function getBodyPayment(formResponses, data, tokenInfo, bodyP) {
  const configuration = {
    ...bodyP.configuration,
    channel: tokenInfo && tokenInfo.usuarioId ? "agente" : "directo",
  };
  const email= getValueField("correoAgente", formResponses);
  const user = {
    name: tokenInfo && tokenInfo.usuarioId ? tokenInfo.name : "",
    email: tokenInfo && tokenInfo.usuarioId ? email : "",
    phone: tokenInfo && tokenInfo.usuarioId ? tokenInfo.phone : "",
  };
  const policy = {
    currency: "MXN",
    formPayment: "",
    periodicity: "",
    quote: { ...data.infoRequote.res.data.policy },
    costs: { ...data.infoRequote.res.data.costs },
  };
  const policyP = {
    ...bodyP.policy,
    userId: tokenInfo ? tokenInfo.usuarioId : "",
    effectiveDate: formatDate(
      getValueField("fechaApartirDe", formResponses),
      "/"
    ),
  };
  const situation = {
    ...bodyP.situation,
    vehicleSerialNumber: getValueField("serialNumber", formResponses),
  };
  const coverages = bodyP.coverages;
  const formPayment = {
    periodicityPaymentId: "12",
    paymentMethodId: "3",
    paymentMethodDescrip: "TARJETA",
  };
  const personalDataInsu = {
    internalIdentifier: "",
    typeIdentifierId: "1",
    typeLegalId: "1",
  };
  const addressInsu = { countryId: "052", zoneDescription: "" };
  const personalClient = {};
  const addressClient = { countryId: "052" };
  const preferentialBeneficiary = getPreferency(formResponses);
  keysPersonalData("Asegurado", "", formResponses).forEach((keyPerson) => {
    if (keyPerson.value) {
      personalDataInsu[keyPerson.key] = keyPerson.value;
    } else {
      let findData = formResponses.find((e) => e.key === keyPerson.keyResp);
      if (findData) {
        personalDataInsu[keyPerson.key] = findData.value ? findData.value : "";
      }
    }
  });
  keysAddres("Asegurado").forEach((keyPerson) => {
    const findData = formResponses.find((e) => e.key === keyPerson.keyResp);
    if (findData) {
      addressInsu[keyPerson.key] = findData.value ? findData.value : "";
    }
  });
  keysPersonalData("Contratante", "Contratante", formResponses).forEach(
    (keyPerson) => {
      if (keyPerson.value) {
        personalClient[keyPerson.key] = keyPerson.value;
      } else {
        const findData = formResponses.find((e) => e.key === keyPerson.keyResp);
        if (findData) {
          if (
            findData.key === "sexoContratante" &&
            (findData.value.includes("HOMBRE") ||
              findData.value.includes("MUJER"))
          ) {
            findData.value = findData.value === "HOMBRE" ? "H" : "M";
          }
          personalClient[keyPerson.key] = findData.value ? findData.value : "";
        } else {
          personalClient[keyPerson.key] = "";
        }
      }
    }
  );
  keysAddres("Contratante").forEach((keyPerson) => {
    let findData = formResponses.find((e) => e.key === keyPerson.keyResp);
    if (findData) {
      if (findData.key === "estadoContratante" || findData.key === "coloniaContratante") {
        let find = findData.valuesResponse.find(
          (e) => e.descripcion === findData.value
        );
        findData.value = find ? find.clave : findData.value;
      }
      addressClient[keyPerson.key] = findData.value ? findData.value : "";
    } else {
      addressClient[keyPerson.key] = "";
    }
  });
  return {
    configuration,
    user,
    policy,
    jsonIssue: {
      configuration,
      policy: policyP,
      situation,
      coverages,
      insured: {
        personalData: personalDataInsu,
        address: addressInsu,
      },
      regularDriver: {
        personalData: personalDataInsu,
        address: addressInsu,
      },
      preferentialBeneficiary: preferentialBeneficiary,
      client: {
        personalData: personalClient,
        address: addressClient,
      },
      formPayment,
    },
  };
}

export function getBody(body, model, formResponses, insureds, user, aditional) {
  const bodyValues = Object.keys(body).length;
  if (model) {
    const copyModel = JSON.parse(JSON.stringify(model));
    if (bodyValues == 0) {
      Object.keys(copyModel).forEach((key1) => {
        switch (key1) {
          case "policy":
            const policyKeys = Object.keys(
              copyModel[key1] ? copyModel[key1] : {}
            );
            const newPolicy = {};
            policyKeys &&
              policyKeys.forEach((pKey) => {
                const kValue = user[newKeySituations[2][pKey]]
                  ? user[newKeySituations[2][pKey]]
                  : copyModel[key1][pKey];
                newPolicy[pKey] = kValue;
              });
            copyModel[key1] = newPolicy;
            break;
          case "situations":
            const situations = [];
            const newInsureds =
              insureds && insureds.length > 0 ? insureds : [{ type: "T" }];
            const situationsKeys = Object.keys(
              copyModel[key1][0] ? copyModel[key1][0] : {}
            );
            newInsureds &&
              newInsureds.forEach((insured, index) => {
                const newInsured = {};
                situationsKeys &&
                  situationsKeys.forEach((sKey) => {
                    const value =
                      sKey === "riskNumber"
                        ? index + 1
                        : (insured.type === "T" || sKey === "zipCodeId") &&
                          getValueField(
                            newKeySituations[0][sKey],
                            formResponses
                          );
                    const newKey = newKeySituations[1][sKey]
                      ? newKeySituations[1][sKey]
                      : sKey;
                    const newValue = value
                      ? value
                      : insured[newKey]
                      ? insured[newKey]
                      : copyModel[key1][0][sKey];
                    newInsured[sKey] =
                      sKey !== "birthdate"
                        ? newValue
                        : moment(newValue, ["DD/MM/YYYY", "YYYY-MM-DD"]).format(
                            "YYYY-MM-DD"
                          );
                  });
                situations.push(newInsured);
              });
            copyModel[key1] = situations;
            break;
          case "coverages":
            copyModel[key1] &&
              Object.keys(copyModel[key1]).forEach((cove) => {
                copyModel[key1][cove] = aditional[cove]
                  ? !aditional[cove]
                  : true;
              });
            break;
          default:
            typeof copyModel[key1] === "object" &&
              Object.keys(copyModel[key1]).forEach((key2) => {
                if (typeof copyModel[key1][key2] === "object") {
                  copyModel[key1][key2] &&
                    Object.keys(copyModel[key1][key2]).forEach((key3) => {
                      const personType =
                        copyModel[key1][key2]["personType"] === "personaMoral"
                          ? "Moral"
                          : "";
                      const keyField1 =
                        key1 === "client"
                          ? `${
                              personType && NewKeysContratanteMoral[key3]
                                ? NewKeysContratanteMoral[key3]
                                : NewKeysContratante[key3] || key3
                            }Contratante${key3 === "rfc" ? personType : ""}`
                          : NewKeys[key3] || key3;
                      const fieldVal = formResponses.find(
                        (item) => item.key === keyField1
                      );
                      const valueFieldVal =
                        fieldVal && key3 === "birthdate"
                          ? moment(fieldVal.value, [
                              "DD/MM/YYYY",
                              "YYYY-MM-DD",
                            ]).format("YYYY-MM-DD")
                          : key3 === "typeLegalId"
                          ? personType
                            ? "2"
                            : "1"
                          : fieldVal &&
                            fieldVal.type === "select" &&
                            (fieldVal.data.values || fieldVal.valuesResponse) &&
                            IdsKeysDescription[key3]
                          ? getDescriptionSelect(
                              fieldVal.value,
                              fieldVal.data.values || fieldVal.valuesResponse
                            )
                          : fieldVal && fieldVal.value
                          ? fieldVal.value
                          : copyModel[key1][key2][key3];
                      const value = getConvert(
                        valueFieldVal,
                        typeof copyModel[key1][key2][key3]
                      );
                      copyModel[key1][key2][key3] = value;
                    });
                } else {
                  const keyField = NewKeys[key2] || key2;
                  const field = formResponses.find((x) => x.key === keyField);
                  let valueField =
                    field &&
                    field.type === "select" &&
                    (field.data.values || field.valuesResponse) &&
                    IdsKeysDescription[key2]
                      ? getDescriptionSelect(
                          field.value,
                          field.data.values || field.valuesResponse
                        )
                      : field && field.value
                      ? field.value
                      : copyModel[key1][key2];
                  if (keyField === "claveTipoFamilia") {
                    const allCoverage = formResponses.find(
                      (x) => x.key === "coberturas"
                    )
                      ? formResponses.find((x) => x.key === "coberturas").value
                      : null;
                    const coverageGF =
                      allCoverage &&
                      allCoverage.length > 0 &&
                      allCoverage.find((xc) => xc.claveCobertura === "9198");
                    valueField =
                      coverageGF && coverageGF.checks
                        ? coverageGF.checks
                        : copyModel[key1][key2];
                  }
                  const value = getConvert(
                    valueField,
                    typeof copyModel[key1][key2]
                  );
                  copyModel[key1][key2] = value;
                }
              });
            break;
        }
      });
      return copyModel;
    } else {
      return body;
    }
  } else {
    return body;
  }
}

const getPreferency = (formResponses) => {
  const findPreferency = getValueField("rfcPreferente", formResponses);
  const razonSocial = getValueField("razonSocialPreferente", formResponses);

  if (findPreferency && razonSocial) {
    const personalData = {
      internalIdentifier: "",
      typeIdentifierId: "1",
      typeLegalId: (findPreferency.length === 13 || findPreferency.length === 10) ? "1" : "2",
      rfc: findPreferency,
      businessName:
        (findPreferency.length === 12 || findPreferency.length === 9) ? razonSocial.substring(0, 69) : "",
      name:
        (findPreferency.length === 13 || findPreferency.length === 10)
          ? razonSocial.substring(0, 19)
          : razonSocial,
      secondName: "",
      surname: "",
      secondSurname: "",
      birthdate: getBirthdate(findPreferency),
      gender: (findPreferency.length === 13 || findPreferency.length === 10) ? "H" : "E",
      email: "",
      phoneNumber: "",
      equipment: "",
    };
    return { personalData, address: null };
  } else {
    return null;
  }
};

export const getBirthdate = (rfc) => {
  const anio = new Date().getFullYear().toString().substring(2, 4);
  let replRfc = "";
  let month = "";
  let day = "";
  if (rfc.length === 13 || rfc.length === 10) {
    replRfc = rfc.substring(4, 6);
    month = rfc.substring(6, 8);
    day = rfc.substring(8, 10);
  } else {
    replRfc = rfc.substring(3, 5);
    month = rfc.substring(5, 7);
    day = rfc.substring(7, 9);
  }
  const anioRFC = replRfc <= anio ? `20${replRfc}` : `19${replRfc}`;
  return `${anioRFC}-${month}-${day}`;
};

export const getValueEqual = (value, responses) => {
  if (value && responses) {
    let val = responses.find((e) => e.clave === value);
    if (val) {
      return val.descripcion;
    }
  }
  return "";
};

export const getUrlFiscal = (opciones_servicio, key) => {
  opciones_servicio = JSON.parse(opciones_servicio);
  let url = opciones_servicio.url.replace("value", "1");
  if (key === "personaMoral") {
    url = opciones_servicio.url.replace("value", "2");
  }
  opciones_servicio.url = url;
  return opciones_servicio;
};

const IdsKeysDescription = {
  coloniaDescripcion: true,
  colonyDescription: true,
  municipioDescripcion: true,
  ciudadDescripcion: true,
  estadoDescripcion: true,
  paisDescripcion: true,
  descripcionOcupacion: true,
  descripcionNacionalidad: true,
  tipoDeIdentificacionEntregada: true,
  parentescoDescripcion: true,
  generoDescripcion: true,
  generoMascotDescripcion: true,
  tipoMascotaDescripcion: true,
  paisResideFiscalmente: true,
  estadoCivilDescripcion: true,
  generoMascotDescripcion: true,
  tipoMascotaDescripcion: true,
  zoneDescription: true,
};

export const newKeySituations = [
  {
    kinship: "type",
    name: "nombre",
    birthdate: "fechaNacimiento",
    phoneNumber: "telefono",
    gender: "genero",
    email: "email",
    zipCodeId: "codigoPostal",
  },
  {
    kinship: "type",
    birthdate: "age",
    zipCodeId: "codigoPostal",
  },
  {
    officeId: "oficinaId",
    productId: "ramoId",
    atrGroupId: "atrGrupoId",
    atrSubgroupId: "atrSubgrupoId",
    atrProfileRateId: "atrPerfilTarifaId",
    atrPointSaleId: "atrPuntoVentaId",
    userId: "usuarioId",
    name: "name",
    email: "email",
  },
];

const NewKeys = {
  rfc: "identificadorPersona",
  firmaElectronica: "eFirma",
  telefonoClaveLada: "telefonoExtranjero",
  otraNacionalidad: "otrasNacionalidades",
  paisResideFiscalmente: "paisResidenteFiscal",
  paisResideFiscalmenteDescripcion: "paisResidenteFiscal",
  numIdExtranjero: "nIdentificacionEnElExtranjero",
  ingresoMensual: "ingresosMensuales",
  paisNacimiento: "pais",
  calleNumeroExt: "nExterior",
  calleNombre: "direccion",
  numeroDepartamentoInterno: "calleNumInterior",
  codigoPostalId: "codigoPostal",
  coloniaId: "coloniaAsegurado",
  estadoId: "estadoAsegurado",
  paisId: "pais",
  municipioId: "municipioAsegurado",
  ciudadId: "ciudadAsegurado",
  ocupacion: "claveOcupacion",
  tipoJuridicoIdContratante: "tipoDePersonaContratante",
  coloniaDescripcion: "coloniaAsegurado",
  municipioDescripcion: "municipioAsegurado",
  ciudadDescripcion: "ciudadAsegurado",
  estadoDescripcion: "estadoAsegurado",
  paisDescripcion: "pais",
  descripcionOcupacion: "claveOcupacion",
  descripcionNacionalidad: "nacionalidad",
  parentescoDescripcion: "parentesco",
  generoDescripcion: "genero",
  folioFromPartner: "folio",
};

const NewKeysUrl = {
  codigoPostalContratante: "codigoPostal",
  identificadorPersonaContratante: "identificadorPersona",
  identificadorPersonaContratanteMoral: "identificadorPersona",
  codigoPostalFacturacionPreferenteContratante: "codigoPostal",
};

const keysUrls = {
  identificadorPersona: true,
  codigoPostal: true,
};

const MapKeysUrl = {
  apePaterno: "primerApellido",
  apeMaterno: "segundoApellido",
  RFC: "identificadorPersona",
  primerNombreContratante: "razonSocialContratante",
  fechaNacimientoContratante: "fechaDeConstitucionContratante",
  identificadorPersonaContratante: "identificadorPersonaContratanteMoral",
};

const keysPersonalData = (key, typePerson, formResponses) => {
  let array = [];
  let flagTypePerson = false;
  if (typePerson) {
    let type = "1";
    array.push({
      key: "internalIdentifier",
      keyResp: "internalIdentifierContratante",
    });
    const findType = formResponses.find(
      (e) => e.key === "tipoDePersonaContratante"
    );
    if (findType && findType.value.includes("Moral")) {
      type = "2";
      typePerson = "ContratanteMoral";
      flagTypePerson = true;
    } else {
      typePerson = "Contratante";
    }
    let arr = [
      { key: "typeIdentifierId", value: "1" },
      { key: "typeLegalId", value: type },
      { key: "taxReformId", keyResp: `regimenFiscalPreferenteContratante` },
      {
        key: "receiverCode",
        keyResp: "codigoPostalFacturacionPreferenteContratante",
      },
      { key: "businessName", keyResp: "razonSocialContratante" },
    ];
    array = [...array, ...arr];
  }
  const keys = [
    { key: "rfc", keyResp: `identificadorPersona${typePerson}` },
    { key: "name", keyResp: `primerNombre${key}` },
    { key: "secondName", keyResp: `segundoNombre${key}` },
    { key: "surname", keyResp: `primerApellido${key}` },
    { key: "secondSurname", keyResp: `segundoApellido${key}` },
    {
      key: "birthdate",
      keyResp: flagTypePerson
        ? "fechaDeConstitucionContratante"
        : `fechaNacimiento${key}`,
    },
    { key: "phoneNumber", keyResp: `telefonoCelular${key}` },
    { key: "email", keyResp: `email${key}` },
  ];
  if (flagTypePerson) {
    keys.push({ key: "gender", value: "E" });
  } else {
    keys.push({ key: "gender", keyResp: `sexo${key}` });
  }
  return [...array, ...keys];
};

const keysAddres = (key) => {
  return [
    {
      key: "streetName",
      keyResp: `direccion${key}`,
    },
    {
      key: "streetNumberExt",
      keyResp: `nExterior${key}`,
    },
    {
      key: "internalDepartmentNumber",
      keyResp: `calleNumInterior${key}`,
    },
    {
      key: "abbreviationsDomicile",
      keyResp: `direccion${key}`,
    },
    {
      key: "zipCodeId",
      keyResp: `codigoPostal${key}`,
    },
    {
      key: "colonyId",
      keyResp: `colonia${key}`,
    },
    {
      key: "stateId",
      keyResp: `estado${key}`,
    },
  ];
};

const NewKeysContratante = {
  personType: "tipoDePersona",
  rfc: "identificadorPersona",
  businessName: "razonSocial",
  name: "primerNombre",
  secondName: "segundoNombre",
  surname: "primerApellido",
  secondSurname: "segundoApellido",
  birthdate: "fechaNacimiento",
  gender: "sexo",
  phoneNumber: "telefonoCelular",
  email: "email",
  streetName: "direccion",
  streetNumberExt: "nExterior",
  internalDepartmentNumber: "calleNumInterior",
  zipCodeId: "codigoPostal",
  colonyId: "colonia",
  colonyDescription: "colonia",
  municipalityId: "municipio",
  stateId: "estado",
};

const keysCoverages = [
  { key: "versionVehiculo", value: "subBrandAmis" },
  { key: "model", value: "vehicleModel" },
  { key: "fechaNacimiento", value: "regularDriverAge" },
  { key: "codigoPostal", value: "zipCodeId" },
  { key: "telefono", value: "driversPhoneNumber" },
  { key: "email", value: "email" },
];

const NewKeysContratanteMoral = {
  birthdate: "fechaDeConstitucion",
  name: "razonSocial",
  gender: "generoPersonaMoral",
  secondName: " ",
  surname: " ",
  secondSurname: " ",
};

export const InsuredKeys = [
  { M: "Femenino", H: "Masculino" },
  { M: "Hija", H: "Hijo" },
  { T: "Titular", C: "Cónyuge", H: "Hija (o)" },
  {
    parentescoAsegurado: "type",
    generoAsegurado: "gender",
    fechaNacimientoAsegurado: "age",
  },
  { T: "titular", C: "adicional", H: "adicional" },
];

export function getDescriptionSelect(key, valuesResponse) {
  const description =
    valuesResponse &&
    valuesResponse.find((item) => (item.clave || item.value) === key);
  return description && description.descripcion
    ? description.descripcion
    : description && description.label
    ? description.label
    : "";
}

export function getConvert(value, type) {
  switch (type) {
    case "number":
      value = Number(value);
      break;
    case "string":
      value = String(value);
      break;
  }
  return value;
}

export function getKeys(current) {
  return (
    current && current.newItems && current.newItems.map((value) => value.key)
  );
}

export function formatPrice(priceValue) {
  let priceparts = [];
  if (priceValue) {
    const priceSplit = priceValue.toString().split(".");
    const transformPrice = priceSplit[0];
    priceparts.push(transformPrice);
    if (priceSplit.length > 1 && priceSplit[1]) {
      priceparts.push(priceSplit[1]);
    }
  }
  let newPrice = Math.round(Number(priceparts.join(".")) * 100) / 100;
  newPrice = Math.trunc(newPrice);
  return `$ ${newPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

export function getDependencyValue(current, key, value, showField) {
  const conditionalFields =
    current &&
    current.newItems.filter(
      (valu) => valu && valu.conditional && valu.conditional.when === key
    );

  conditionalFields &&
    conditionalFields.length > 0 &&
    conditionalFields.forEach((conditionalField) => {
      getDependencyValue(
        current,
        conditionalField.key,
        conditionalField.value ? conditionalField.value : "",
        showField
      );
      const show =
        conditionalField.conditional.eq === value
          ? !conditionalField.conditional.show
          : conditionalField.conditional.show;
      showField.push({ [conditionalField.key]: show });
    });
  return showField;
}

export function getValueField(key, formResponses) {
  const field = formResponses.find((value) => value.key === key);
  return field && field.value ? field.value : "";
}

export const fieldsClear = [
  "identificadorPersonaContratante",
  "identificadorPersonaContratanteMoral",
  "primerNombreContratante",
  "segundoNombreContratante",
  "primerApellidoContratante",
  "segundoApellidoContratante",
  "fechaDeConstitucionContratante",
  "razonSocialContratante",
  "sexoContratante",
  "direccionContratante",
  "fechaNacimientoContratante",
  "emailContratante",
  "telefonoCelularContratante",
  "nExteriorContratante",
  "calleNumInteriorContratante",
  "codigoPostalContratante",
  "estadoContratante",
  "coloniaContratante",
];

export function getInfoField(key, stepKey, components) {
  const fields =
    components && components.find((comp) => comp.title === stepKey);
  const field = fields && fields.components.find((fd) => fd.key === key);
  return field ? field : {};
}

export function getPercentage(item, steps) {
  let value = String((item.current * 100) / item.quantity);

  return item.active ? item.current : 0;
}

export function replaceAtrBody(body, tokenInfo) {
  const bodyKeys = Object.keys(body);
  const copyModel = { ...body };
  bodyKeys.forEach((key) => {
    if (Object.hasOwnProperty.call(tokenInfo, key)) {
      copyModel[key] = tokenInfo[key];
    }
  });
  return copyModel;
}

export function getSidebarCoverage(modalitie, formResponses) {
  keysSideBarResume.data.forEach((dat) => {
    dat.items.forEach((it) => {
      if (it.key === "4") {
        let values = [];
        const findCoverages = formResponses.find((e) => e.key === "coberturas");
        if (findCoverages && findCoverages.coverages.length) {
          findCoverages.coverages.forEach((cov) => {
            if (cov.optional) {
              values.push({
                label: cov.coverageName,
                value: cov.value,
              });
            }
          });
        }
        it.values = values;
      }
      if (it.key === "3") {
        it.values = it.get(modalitie);
      }
      if (it.key !== "4") {
        it.values.forEach((va) => {
          const findField = formResponses.find(
            (formRes) => formRes.key === va.key
          );
          if (findField) {
            if (va.get) {
              va.value = va.get(findField);
            }
          }
        });
      }
    });
  });
  return keysSideBarResume.data;
}

const getValueDate = (date) => {
  const age = getDate(date);
  return age.toString();
};

export const getValueCoverage = (modalitie) => {
  let coveragesChoose = [];
  let coveragesSelected = [];
  if (modalitie.coverages && modalitie.coverages.length) {
    coveragesChoose.push({
      label: modalitie.modality,
      value: modalitie.value,
    });
    modalitie.coverages.forEach((e) => {
      if (!e.optional) {
        coveragesSelected.push({
          label: e.coverageName,
          value: ``,
        });
      }
    });
    coveragesChoose = [...coveragesChoose, ...coveragesSelected];
  }
  return coveragesChoose;
};

const getValuesVehicle = (key, valueResponse) => {
  let obje = {};
  if (valueResponse && valueResponse.length) {
    const findResponse = valueResponse.find((v) => v.key === key);
    if (findResponse) {
      obje = {
        vehicleAmountSumInsurance: findResponse.properties.amountSumInsurance,
        collisionWarning: findResponse.properties.collisionWarning,
        ecoFriendly: findResponse.properties.ecoFriendly,
      };
    }
  }
  return obje;
};

export let keysSideBarResume = {
  data: [
    {
      items: [
        {
          key: "1",
          title: "Datos personales",
          values: [
            {
              key: "fechaNacimiento",
              label: "EDAD",
              get: (date) => getValueDate(date.value),
              value: "",
            },
            {
              key: "codigoPostal",
              label: "CODIGO POSTAL",
              get: (val) => val.value,
              value: "",
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          key: "2",
          title: "Vehículo",
          values: [
            {
              key: "vehiclemake",
              label: "MARCA",
              value: "",
              get: (val) => val.description,
            },
            {
              key: "model",
              label: "MODELO",
              value: "",
              get: (val) => val.value.toString(),
            },
            {
              key: "versionVehiculo",
              label: "VERSION",
              value: "",
              get: (val) => val.value.description,
            },
          ],
        },
      ],
    },
    {
      key: "coverages",
      items: [
        {
          key: "3",
          title: "Coberturas",
          get: (coverages) => getValueCoverage(coverages),
          values: [],
        },
      ],
    },
    {
      key: "coverageA",
      items: [
        {
          key: "4",
          title: "Coberturas adicionales",
          values: [],
        },
      ],
    },
  ],
};

export function getSidebarData(data, formResponses) {
  const dataCopy = [...data];
  const sidebarData = { title: "ASEGURADOS", items: [] };
  const newDate = getValueField("fechaNacimiento", formResponses);
  if (!dataCopy || dataCopy.length === 0) {
    const genderKey = getValueField("genero", formResponses);

    dataCopy.push({
      key: moment().unix(),
      type: "T",
      gender: genderKey,
      age: newDate,
    });
  }

  sidebarData.items =
    dataCopy &&
    dataCopy.map((element) => ({
      title: InsuredKeys[2][element.type],
      values: [
        {
          rows: [
            {
              label: "NOMBRE",
              value: element.name ? element.name.toUpperCase() : "",
            },
            {
              label: "EDAD",
              value: moment().diff(
                moment(element.type === "T" ? newDate : element.age, [
                  "DD/MM/YYYY",
                  "YYYY-MM-DD",
                ]),
                "years"
              ),
            },
            {
              label: "GÉNERO",
              value: InsuredKeys[0][element.gender]?.toUpperCase(),
            },
          ],
        },
      ],
    }));

  return [sidebarData];
}

export function getPriceToShow(coverages) {
  let total = 0;
  coverages &&
    coverages.length > 0 &&
    coverages.forEach((coverage) => {
      total = total + coverage.totalAmount;
    });
  return total + total * Number(process.env.REACT_APP_TAX_PERCENTAGE);
}

export function filterObject(obj, value) {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => key.includes(value))
  );
}

export function getNewObject(fieldsValues, type, index) {
  let newObj = fieldsValues
    ? {
        rfc: fieldsValues[`identificadorPersona${type}-${index}`],
        name: fieldsValues[`primerNombre${type}-${index}`],
        secondName: fieldsValues[`segundoNombre${type}-${index}`],
        surname: fieldsValues[`primerApellido${type}-${index}`],
        secondSurname: fieldsValues[`segundoApellido${type}-${index}`],
        birthdate: moment(fieldsValues[`fechaNacimiento${type}-${index}`], [
          "DD/MM/YYYY",
          "YYYY-MM-DD",
        ]).format("YYYY-MM-DD"),
        type: "personaFisica",
      }
    : {};
  return newObj;
}

export function validateForm(fields, form) {
  return form
    .validateFields(fields, () => {})
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
}

export function encrypt(data, key) {
  const ciphertext = CryptoJS.AES.encrypt(data, key).toString();
  const dataBase64 = Buffer.from(ciphertext).toString("base64");
  return dataBase64;
}

export function decrypt(data, key) {
  return CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
}

export const getDate = (value) => {
  return moment().diff(moment(value, ["DD/MM/YYYY", "YYYY-MM-DD"]), "years");
};

export function validateDiff(type, dateField, insureds, insuredAge) {
  let validate = false;
  const difference =
    dateField && dateField.properties && dateField.properties.difference;
  if (difference && Number(difference) !== 0 && type === "H") {
    // si la diferencia es 0 se desactiva la validación -> false -> no arroja fecha inválida
    const holderInfo = insureds.find((x) => x.type === "T");
    const holderAge = getDate(holderInfo && holderInfo.age);
    validate = holderAge - insuredAge < Number(difference);
  }
  return validate;
}

export function validateIsBefore(persistence) {
  let result = {};
  if (
    persistence &&
    persistence.payment &&
    persistence.urlPayment &&
    persistence.urlPayment.length > 0
  ) {
    const statusFolio =
      persistence.configuracion && persistence.configuracion.estadoFlujo;
    const objPayment = persistence.payment[persistence.payment.length - 1];
    const statusPayment = objPayment.payment.status || "";
    const url = persistence.urlPayment[persistence.urlPayment.length - 1];
    result = {
      url: url.urlRedirect,
      isBefore:
        statusFolio === "Pendiente"
          ? true
          : statusPayment && statusPayment === "canceled"
          ? false
          : url && url.validity && moment().isBefore(moment(url.validity)),
    };
  }
  return result;
}

export function replaceBrand(text, vehicleMake, key) {
  let label = text;
  if (text && text.includes(`{{${key}}}`) && vehicleMake) {
    label = text.replace(`{{${key}}}`, vehicleMake);
  }
  return label;
}

export function coverageChoosed(
  coveragesSelect,
  modality,
  modalities,
  coveragesAdd
) {
  let otherCoverage = [];
  let selectedCoverages = [];
  coveragesAdd.forEach((cov) => {
    let copy = { ...cov };
    const findSelect = coveragesSelect.find(
      (e) => e.coverageId === cov.coverageId
    );
    if (findSelect) {
      copy.choosed = findSelect.choosed;
    }
    if (!cov.modalities[modality.modalityId]) {
      otherCoverage.push({ choosed: false, ...cov });
    } else {
      copy.choosed = copy.choosed ? copy.choosed : false;
      selectedCoverages.push(copy);
    }
  });
  modalities.forEach((e) => {
    otherCoverage.forEach((cov) => {
      if (cov.modalities[e.modalityId] && !cov["modality"]) {
        cov["modality"] = e.modality;
      }
    });
  });
  return { selectedCoverages, otherCoverage };
}

export function coveragesSelected(modalitie, coverages, modalities) {
  let coverageSelect = [];
  let otherCoverage = [];
  let coverageSelectAdd = [];
  coverages.forEach((e) => {
    if (e.modalities[modalitie.modalityId]) {
      if (!e.optional) {
        coverageSelect.push({ choosed: false, ...e });
      } else {
        let choosed = false;
        if (modalitie.coverages && modalitie.coverages.length) {
          choosed = modalitie.coverages.find(
            (cov) => e.coverageId === cov.coverageId
          )
            ? true
            : false;
        }
        coverageSelectAdd.push({ choosed, ...e });
      }
    } else {
      otherCoverage.push({ choosed: false, ...e });
    }
  });
  if (!modalities) {
    return coverageSelect;
  }
  modalities.forEach((e) => {
    otherCoverage.forEach((cov) => {
      if (cov.modalities[e.modalityId] && !cov["modality"]) {
        cov["modality"] = e.modality;
      }
    });
  });
  otherCoverage = otherCoverage.sort((a, b) =>
    a.modality > b.modality ? 1 : -1
  );
  return { coverageSelect: coverageSelectAdd, otherCoverage };
}

export const paramsOfUrl = {
  step_emision_asegurado: {
    params: [
      {
        keyParams: "tipoPersona",
        keyFormResponse: "tipoDePersonaAsegurado",
      },
      {
        keyParams: "RFC",
        keyFormResponse: "identificadorPersona",
      },
      {
        keyParams: "nombre",
        keyFormResponse: "primerNombreAsegurado",
      },
      {
        keyParams: "segNombre",
        keyFormResponse: "segundoNombreAsegurado",
      },
      {
        keyParams: "apePaterno",
        keyFormResponse: "primerApellidoAsegurado",
      },
      {
        keyParams: "apeMaterno",
        keyFormResponse: "segundoApellidoAsegurado",
      },
      {
        keyParams: "fechaNacimiento",
        keyFormResponse: "fechaNacimientoAsegurado",
      },
    ],
  },
  step_emision_contratante: {
    params: [
      {
        keyParams: "tipoPersona",
        keyFormResponse: "tipoDePersonaContratante",
      },
      {
        keyParams: "RFC",
        keyFormResponse: "identificadorPersonaContratante",
      },
      {
        keyParams: "nombre",
        keyFormResponse: "primerNombreContratante",
      },
      {
        keyParams: "segNombre",
        keyFormResponse: "segundoNombreContratante",
      },
      {
        keyParams: "apePaterno",
        keyFormResponse: "primerApellidoContratante",
      },
      {
        keyParams: "apeMaterno",
        keyFormResponse: "segundoApellidoContratante",
      },
      {
        keyParams: "fechaNacimiento",
        keyFormResponse: "fechaNacimientoContratante",
      },
    ],
    params_moral: [
      {
        keyParams: "tipoPersona",
        keyFormResponse: "tipoDePersonaContratante",
      },
      {
        keyParams: "RFC",
        keyFormResponse: "identificadorPersonaContratanteMoral",
      },
      {
        keyParams: "nombre",
        keyFormResponse: "razonSocialContratante",
      },
      {
        keyParams: "fechaNacimiento",
        keyFormResponse: "fechaDeConstitucionContratante",
      },
    ],
  },
};

export function getUrlWithParams(servicio, stepsParams, formResponses, step) {
  let url = servicio.url;
  let params = stepsParams.params;
  if (step.includes("contratante")) {
    const identifierPerson = formResponses.find(
      (e) => e.key === "tipoDePersonaContratante"
    ).value;
    if (identifierPerson.includes("Moral")) {
      params = stepsParams.params_moral;
    }
  }
  params.forEach((e, index) => {
    const findValue = formResponses.find(
      (formRes) => formRes.key === e.keyFormResponse
    );
    if (findValue && findValue.value) {
      const ampersand = stepsParams.params.length - 1 === index ? "" : "&";
      url = `${url}${e.keyParams}=${findValue.value}${ampersand}`;
    }
  });
  servicio.url = url;
  return servicio;
}

const keysTypePerson = {
  descripcionDomicilioAsegurado: "direccionAsegurado",
  numeroAsegurado: "nExteriorAsegurado",
  telefonoAsegurado: "telefonoCelularAsegurado",
  numeroContratante: "nExteriorContratante",
  descripcionDomicilioContratante: "direccionContratante",
  telefonoContratante: "telefonoCelularContratante",
  nombreCompletoContratante: "razonSocialContratante",
  fechaNacimientoContratante: "fechaDeConstitucionContratante",
};

const keysPersonMoral = {
  fechaNacimientoContratante: "fechaDeConstitucionContratante",
  nombreCompletoContratante: "razonSocialContratante",
  descripcionDomicilioContratante: "direccionContratante",
  codigoPostalContratante: "codigoPostalContratante",
  estadoContratante: "estadoContratante",
  coloniaContratante: "coloniaContratante",
  identificadorPersonaContratanteMoral: "identificadorPersonaContratanteMoral",
  tipoDePersonaContratante: "tipoDePersonaContratante",
  telefonoContratante: "telefonoCelularContratante",
  emailContratante: "emailContratante",
  numeroContratante: "nExteriorContratante",
  numeroInternoContratante: "calleNumInteriorContratante"
};

const keysPersonFisica = {
  primerNombreContratante: "primerNombreContratante",
  segundoNombreContratante: "segundoNombreContratante",
  primerApellidoContratante: "primerApellidoContratante",
  segundoApellidoContratante: "segundoApellidoContratante",
  sexoContratante: "sexoContratante",
  fechaNacimientoContratante: "fechaNacimientoContratante",
  emailContratante: "emailContratante",
  telefonoContratante: "telefonoCelularContratante",
  descripcionDomicilioContratante: "direccionContratante",
  numeroContratante: "nExteriorContratante",
  codigoPostalContratante: "codigoPostalContratante",
  estadoContratante: "estadoContratante",
  coloniaContratante: "coloniaContratante",
  identificadorPersonaContratante: "identificadorPersonaContratante",
  tipoDePersonaContratante: "tipoDePersonaContratante",
  numeroInternoContratante: "calleNumInteriorContratante"
};
export function getValueTypePerson(key, formResponses) {
  if (key.includes("Contratante")) {
    let type = "";
    const fieldValue = getValueField("tipoDePersonaContratante", formResponses);
    type =
      fieldValue && fieldValue === "personaFisica"
        ? keysPersonFisica
        : keysPersonMoral;
    return type[key];
  }
  if (keysTypePerson[key]) {
    key = keysTypePerson[key];
  }
  if (key === "codigoPostalAsegurado" || key === "coloniaAsegurado") {
    return "";
  }
  return key;
}

export function formatDate(date, separator) {
  if (!date) {
    return "";
  }
  const format = date.split(separator);
  return `${format[2]}-${format[1]}-${format[0]}`;
}
